//home page product slider:

document.addEventListener("DOMContentLoaded", function () {
  // function updateQuantityWhenReady(selector, value = 5) {
  //     const input = document.querySelector(selector);
  //     input.value = value;
  //     console.log('Quantity set to:', value);
  // }
  
  // updateQuantityWhenReady('.quantity__input.custom-quantity-input', 15);


    // let qty = document.querySelector(".quantity__input.custom-quantity-input");
    // qty.min = 3;

  const productSwiper = new Swiper(".product-slider", {
    loop: false,
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      500: {
        slidesPerView: 2,
      },
      989: {
        slidesPerView: 3,
      },  
    },    
    on: {
      init: function () {
        updateProductProgress(this);
      },
      slideChange: function () {
        updateProductProgress(this);
      },
    },
  });

  function updateProductProgress(swiper) {
    const current = swiper.realIndex + 1;
    const total = swiper.slides.length;

    document.querySelector(".product-current-slide").textContent = current
      .toString()
      .padStart(2, "0");
    document.querySelector(".product-total-slide").textContent = total
      .toString()
      .padStart(2, "0");

    const progress = ((current - 1) / (total - 1)) * 100;
    document.querySelector(
      ".product-progress-fill"
    ).style.width = `${progress}%`;
  }

  //Home page testimonial slider

  // const swiper = new Swiper(".testimonial-container.swiper", {
  //   loop: false,
  //   slidesPerView: 1,
  //   spaceBetween: 20,
  //   on: {
  //     init: function () {
  //       updateProgress(this);
  //     },
  //     slideChange: function () {
  //       updateProgress(this);
  //     },
  //   },
  // });

  // function updateProgress(swiper) {
  //   const current = swiper.realIndex + 1;
  //   const total = swiper.slides.length;

  //   document.querySelector(".current-slide").textContent = current
  //     .toString()
  //     .padStart(2, "0");
  //   document.querySelector(".total-slide").textContent = total
  //     .toString()
  //     .padStart(2, "0");

  //   const progress = ((current - 1) / (total - 1)) * 100;
  //   document.querySelector(".progress-fill").style.width = `${progress}%`;
  // }

  const testimonialSwiper = new Swiper(".testimonial-container.swiper", {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 20,
  on: {
    init: function () {
      updateTestimonialProgress(this);
    },
    slideChange: function () {
      updateTestimonialProgress(this);
    },
  },
});

function updateTestimonialProgress(swiper) {
  const current = swiper.realIndex + 1;
  const total = swiper.slides.length;

  swiper.slides.forEach((slide) => {
    slide.querySelector(".current-slide").textContent = current
      .toString()
      .padStart(2, "0");
    slide.querySelector(".total-slide").textContent = total
      .toString()
      .padStart(2, "0");

    const progress = ((current - 1) / (total - 1)) * 100;
    slide.querySelector(".progress-fill").style.width = `${progress}%`;
  });
}

  
});
